import { asBlock } from '../../../_lib/BlockFetcher';
import { BlockType } from '../../../types/api/ElementType';
import React, { ComponentProps } from 'react';
import ILink from '../../../types/ILink';
import { ProfileImageSmall } from '../../../types/api/ImageType';
import IUrl, { ISonURL } from '../../../types/IUrl';
import { ContentList, ContentListItem } from '../../../_lib/components/ContentList';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AccessLevel } from '../common/types';
import { DateFormat, DateFormats } from '../../../_lib/components/DateFormat';
import { ProfilePictureName } from '../../../_lib/components/ProfilePictureName';
import { Dfn } from '../../../_lib/components/Dfn/Dfn';
import { Hyperlink } from '../../../components/atoms/Hyperlink';

type PendingRequest = {
  profileLink: ILink;
  profileImageUrl: ProfileImageSmall;
  personInfoCardUrl: IUrl;
  requestedAccessLevel: AccessLevel;
  requestDate: string;
  emailLink?: ISonURL;
};

type PendingAccessLevelRequestsBlockProps = {
  requests: PendingRequest[];
};

function PendingAccessLevelRequests({ requests }: PendingAccessLevelRequestsBlockProps) {
  const { t } = useSonTranslation('PendingAccessLevelRequests');

  if (!requests) {
    return null;
  }

  if (requests.length === 0) {
    return <ContentMessage text={t('noPendingRequests')} />;
  }

  return (
    <ContentList>
      {requests.map(request => (
        <ContentListItem key={request.profileLink.name}>
          <ProfilePictureName
            profileLink={request.profileLink}
            profileName={request.profileLink.name}
            profileImageUrl={request.profileImageUrl}
            personInfoCardUrl={request.personInfoCardUrl}
          />
          <div className="access-level__pending-requests-item-container font-regular-14-19">
            {request.emailLink?.url && request.emailLink?.name ? (
              <Hyperlink to={request.emailLink.url} className="definition-list__link">
                {request.emailLink.name}
              </Hyperlink>
            ) : null}
            <p>
              <Dfn>{`${t('requestedAccessLevel')}: `}</Dfn>
              {t(`AccessLevel:form.accessLevels.${request.requestedAccessLevel}.title`)}
            </p>
            <p>
              <Dfn>{`${t('requestDate')}: `}</Dfn>
              <DateFormat date={request.requestDate} format={DateFormats.DATE_TIME} />
            </p>
          </div>
        </ContentListItem>
      ))}
    </ContentList>
  );
}

export const PendingAccessLevelRequestsBlock = asBlock(
  PendingAccessLevelRequests,
  BlockType.pendingaccesslevelrequests
);
export type PendingAccessLevelRequestsBlock = ComponentProps<typeof PendingAccessLevelRequestsBlock>;
